import { render } from "./AppRichText.vue?vue&type=template&id=79b1669f&scoped=true&ts=true"
import script from "./AppRichText.vue?vue&type=script&lang=ts"
export * from "./AppRichText.vue?vue&type=script&lang=ts"

import "./AppRichText.vue?vue&type=style&index=0&id=79b1669f&lang=postcss&scoped=true"

import exportComponent from "/builds/wVusKqw4/0/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b1669f"]])

export default __exports__